export const ultimasNoticias = [
    
    {
        "imagen" : "/assets/imgs/transp2026.jpg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/contraloriat/dir1/Documentos/TRANSP%20EN%20CORTO_CONVOCATORIA_2026.pdf",
        "titulo" : "Concurso Nacional de Transparencia en corto 2026",
        "fecha" : "Tema: Desinformación: Riesgos de la IA"
    },
    {
        "imagen" : "https://s-turismo.hidalgo.gob.mx/assets/imgs/tc1.jpg",
        "url" : "https://www.gob.mx/sectur/acciones-y-programas/resultados-a-la-convocatoria-participa-con-tu-proyecto-de-turismo-comunitario-para-formar-parte-de-la-guia-nacional-de-experiencias",
        "titulo" : "Resultados de la Convocatoria Turismo Comunitario",
        "fecha" : "Conoce los Proyectos por estado"
    },
    {
        "imagen" : "https://s-turismo.hidalgo.gob.mx/assets/imgs/galardon2025.jpg",
        "url" : "https://s-turismo.hidalgo.gob.mx/pdf/galardon2025.pdf",
        "titulo" : "Galardones a la Innovación Turística",
        "fecha" : "Convocatoria 3a Edición Finalizada"
    },
    {
        "imagen" : "https://s-turismo.hidalgo.gob.mx/assets/imgs/pcs2024.jpg",
        "url" : "https://hidalgo.travel/inicio/pueblos-con-sabor/",
        "titulo" : "Pueblos con Sabor",
        "fecha" : "Distintivo PCS 2025"
    },
    {
        "imagen" : "https://s-turismo.hidalgo.gob.mx/assets/imgs/tc.jpg",
        "url" : "https://s-turismo.hidalgo.gob.mx/pdf/convocatoriaTc.pdf",
        "titulo" : "Convocatoria Turismo Comunitario",
        "fecha" : "Finalizada"
    },
    {
        "imagen" : "https://s-turismo.hidalgo.gob.mx/assets/imgs/Tecozautla.jpg",
        "url" : "https://s-turismo.hidalgo.gob.mx/pdf/PueblosMagicos.pdf",
        "titulo" : "Pueblos Mágicos",
        "fecha" : ""
    }
    
]
